<!--
2021-07-18 CHP 新手礼包
2021-10-10 CHP 国际化
2022-03-17 LBL 支持多国家版本，图片从外部传入
2022-03-29 CHP UI调整
2022-10-29 HHY 更换弹窗图片为50%cash奖励，点击进入充值页面并让充值渠道显示50%cash奖励
-->
<template>
  <div class="pop">
    <div class="cancel-btn" @click="close">
      <img :src="closeDeposit">
    </div>
    <div class="bg-in" v-if="this.$store.state.internation == 'IN' || this.$store.state.internation == 'INT'">
      <img
        src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/mlzz1au72ipautoqruct3cjoexhekfilimage_2025_02_26T08_51_44_189Z.webp"
        style="width: 100%;max-width: 750px" alt=""/>
      <div class="button" @click="goToDeposit"/>
      <div class="countdown">
        <div>{{ countdown.substring(0, 2) }}</div>
        <div class="spe"><img
          :src="spe"></div>
        <div>{{ countdown.substring(3, 5) }}</div>
        <div class="spe"><img
          :src="spe"></div>
        <div>{{ countdown.substring(6, 8) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import closeDeposit from '@/assets/images/common/closeDeposit.svg'
import spe from '@/assets/images/common/spe.svg'
import {closePop} from '@/utils'

export default {
  name: 'giftPop',
  props: ['handleClose', 'countdown'],
  data () {
    return {
      spe,
      closeDeposit,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      delayedAWhile: false
    }
  },
  watch: {
  },
  created () {},
  mounted () {
  },
  methods: {
    close () {
      this.handleClose()
    },
    /****
     * 跳转到支付页面
     * 2021-07-31 C007 创建
     * 2022-09-19 Matt 跳转到充值页面
     * 2022-10-29 HHY 告知充值页面充值渠道显示50%cash奖励
     * */
    goToDeposit () {
      closePop(0) // 关闭弹窗并且不弹出其他弹窗
      if (this.userInfo) {
        closePop(1)
        this.$router.push({name: 'Deposit', query: {param: 'firstDeposit'}}) // 告知充值页面充值渠道显示50%cash奖励
      } else {
        // this.$store.commit('setLoginPopShow', true)
        this.$router.push('/Login')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bg-in {
  position: relative;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  width: 100vw;
  height: 158vw;
  max-height: 1185px;
  display: flex;
  overflow: visible;
  justify-content: center;
  align-items: flex-start;
}

.prompt-text {
  font-size: 16px;
  text-align: center;
  color: #F6D9AA;
  line-height: 25px;
  margin: 20px 0px;
}

.deposit-gift-image {
  width: 100%;
  margin: 0 0 20px 0px;
}
.pop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 990;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.button {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 73vw;
  height: 12.5vw;
  bottom: 4vw;
}
.countdown {
  position: absolute;
  top: 78vw;
  font-size: 8.055vw;
  line-height: 8.055vw;
  height: 11.5vw;
  font-weight: 900;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  padding-left: 2vw;

  .spe {
    margin: 0 3.5vw;
    height: 11.5vw;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 6vw;
    }
  }
}

.cancel-btn {
  position: absolute;
  top: 11.388vw;
  left: 82.222vw;
  width: max-content;
  height: max-content;
  z-index: 10;

  img {
    width: 8.611vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DepositGift/index.vue